<template>
    <div class="w_mask select-content">
        <div class="w_mask_bg css_hack"></div>
        <div class="w_mask_content">
            <div class="w_loginPop">
                <div class="w_loginPopWrap">
                    <div class="w_loginPop_txt e_txt" >请先登录文华云，再执行本操作。</div>
                    <div class="w_loginPop_btn" @click.stop="e_login">登录</div>
                    <div class="w_loginPop_btn" @click.stop="e_reg">注册账号</div>
                    <div class="w_loginPop_cancel" @click.stop="$emit('remove')"></div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import wh from '../assets/js/global.js';

export default {
    name: 'GuestPop',
    methods:{
        e_login(){
            this.$emit('remove');
            wh.bridge({
              	class: 'NavigatorPlugin',
                method: 'wh_login',
              	callback: function (echoValue) {
					console.log(echoValue);
				},
              	param: 1
            });
        },
        e_reg(){
            this.$emit('remove');
            wh.bridge({
              	class: 'NavigatorPlugin',
            	method: 'wh_register',
              	callback: function (echoValue) {
               		console.log(echoValue);
              	},
              	param: 1
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@keyframes a_half_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.65;
  }
}
@-webkit-keyframes a_half_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.65;
  }
}
@-moz-keyframes a_half_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.65;
  }
}
@-ms-keyframes a_half_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.65;
  }
}
@-o-keyframes a_half_fade_in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.65;
  }
}

.w_mask, .w_mask_bg, .w_mask_content {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
}

.w_mask_bg {
    opacity: 0.65;
    background: #000;
    animation-name: a_half_fade_in;
    animation-duration: 0.35s;
    -webkit-animation-name: a_half_fade_in;
    -webkit-animation-duration: 0.35s;
}

.w_loginPop {
  top: 37.5%;
  left: 10%;
  width: 80%;
  position: absolute;
}

.w_loginPopWrap {
  border-radius: 0.3em;
  overflow: hidden;
}

.w_loginPop_cancel {
  top: -1.0em;
  right: -1.0em;
  width: 3em;
  height: 3em;
  position: absolute;
  background: #666 url(../assets/images/cancel.svg) no-repeat center;
  background-size: auto 1.3em;
  -o-background-size: auto 1.3em;
  -ms-background-size: auto 1.3em;
  -moz-background-size: auto 1.3em;
  -webkit-background-size: auto 1.3em;
  border-radius: 3em;
}

.w_loginPop_txt {
    color: #696969;
    background: #fff;
    padding: 2em 1.5em;
}

.w_loginPop_txt span {
  color: #EB8B45;
}

.w_loginPop_btn {
    color: #fff;
    background: #f55858;
    padding: 1em 0;
    text-align: center;
    float: left;
    width: 50%;
}

.w_loginPop_btn:active {
    background:#de3a3a;
}

.w_loginPop_btn + .w_loginPop_btn {
    border-left: 1px solid #fff;
    margin-left: -1px;
}
</style>
